import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./threeIcons.module.scss";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import RegFont from "Root/profile/components/common/RegFont";
const ThreeIcons = ({ items, title, cta }) => {
    return (_jsxs("div", { className: styles.threeIconsContainer, children: [_jsx("h2", { className: styles.threeIconsHed, children: title }), _jsx("div", { className: styles.flexContainer, children: items.map((i) => {
                    return (_jsxs("div", { className: styles.flexItem, children: [_jsx("img", { src: i.icon, className: styles.icon }), _jsx(Eyebrow, { children: i.hed }), _jsx(RegFont, { children: i.dek })] }, i.dek + i.hed));
                }) }), cta] }));
};
export default ThreeIcons;
